export const LIST_NURSERY_FRAMEWORK_RELATIONS = 'LIST_NURSERY_FRAMEWORK_RELATIONS'
export const LIST_NURSERY_FRAMEWORK_RELATIONS_SUCCESS = 'LIST_NURSERY_FRAMEWORK_RELATIONS_SUCCESS'
export const LIST_NURSERY_FRAMEWORK_RELATIONS_FAILED = 'LIST_NURSERY_FRAMEWORK_RELATIONS_FAILED'

export const ADD_FRAMEWORK_TO_LIST = 'ADD_FRAMEWORK_TO_LIST'
export const REMOVE_FRAMEWORK_FROM_LIST = 'REMOVE_FRAMEWORK_FROM_LIST'

export const CLEAR_NURSERY_FRAMEWORK_RELATIONS = 'CLEAR_NURSERY_FRAMEWORK_RELATIONS'
